<template>
  <CSidebar fixed :minimize="minimize" colorScheme="dark" :show.sync="show">
    <b-link class="c-sidebar-brand d-md-down-none router-link-active" to="/">
      <h2 class="c-sidebar-brand-full">{{ NomeEmpresa(true) }}</h2>
      <h2 class="c-sidebar-brand-minimized">{{ NomeEmpresa(false) }}</h2>
    </b-link>
    <CRenderFunction flat :content-to-render="MontarMenu()" />
    <CSidebarMinimizer
      class="d-md-down-none"
      @click.native="minimize = !minimize"
    />
  </CSidebar>
</template>

<script>
import Nav from "./_nav";

export default {
  name: "TheSidebar",
  data() {
    return {
      minimize: false,
      show: "responsive"
    };
  },
  mounted() {
    this.$root.$on("toggle-sidebar", () => {
      const sidebarOpened = this.show === true || this.show === "responsive";
      this.show = sidebarOpened ? false : "responsive";
    });
    this.$root.$on("toggle-sidebar-mobile", () => {
      const sidebarClosed = this.show === "responsive" || this.show === false;
      this.show = sidebarClosed ? true : "responsive";
    });
    if (this.$store.state.main.pmauHabilitado === null) {
      this.$store.dispatch("fetchPmauAccess");
    }
    if (this.$store.state.main.pmauAdmin === null) {
      this.$store.dispatch("fetchPmauAdmin");
    }
  },
  methods: {
    NomeEmpresa(full) {
      let nome = "";
      if (
        this.$store.getters.getAutenticacao &&
        this.$store.getters.getAutenticacao.contaSelecionada &&
        this.$store.getters.getAutenticacao.contaSelecionada.apelido
      )
        nome = this.$store.getters.getAutenticacao.contaSelecionada.apelido;
      else nome = "";

      return full ? nome : nome.charAt(0);
    },
    MontarMenu() {
      let menu = [];
      menu.push({
        _name: "CSidebarNav",
        _children: []
      });
      // console.log(Nav);
      let permissao = this.$store.getters.getAutenticacao.permissoes;
      // console.log(permissao);

      menu[0]._children.push(Nav.Dashboard);
      menu[0]._children.push(Nav.Principal);

      if (
        Nav.Project.permission &&
        permissao.filter((x) => x.startsWith(Nav.Project.permission)).length > 0
      )
        menu[0]._children.push(Nav.Project);

      if (
        Nav.Carbono.permission &&
        permissao.filter((x) => x.startsWith(Nav.Carbono.permission)).length > 0
      )
        menu[0]._children.push(Nav.EstoqueCarbono);

      if (
        Nav.Geolocalizacao.permission &&
        permissao.filter((x) => x.startsWith(Nav.Geolocalizacao.permission))
          .length > 0
      )
        menu[0]._children.push(Nav.Geolocalizacao);

      const pmauHabilitado = this.$store.getters.isPmauHabilitado;
      const isPmauAdmin = this.$store.getters.isPmauAdmin;
      const pmauItems = [];
      if (pmauHabilitado) {
        pmauItems.push(Nav.Pmau);
        pmauItems.push(Nav.PmauSurvey);
        pmauItems.push(Nav.PmauWorkshop);
        pmauItems.push(Nav.PmauPublicHearing);
        pmauItems.push(Nav.PmauActionPlan);
        pmauItems.push(Nav.PmauConfiguracao);

        if (isPmauAdmin) pmauItems.push(Nav.PmauPrompts);
      }
      // Fica visível mesmo com o PMAU desabilitado na conta atual — é por
      // aqui que o admin o habilita de novo.
      if (isPmauAdmin) pmauItems.push(Nav.PmauContas);
      if (pmauItems.length) {
        menu[0]._children.push(Nav.PmauTitle);
        // Objeto novo a cada render — não muta o Nav compartilhado.
        menu[0]._children.push({ ...Nav.PmauDropdown, _children: pmauItems });
      }

      //           if (
      //   Nav.Gaau.permission &&
      //   permissao.filter((x) => x.startsWith(Nav.Gaau.permission)).length > 0
      // )
      //   menu[0]._children.push(Nav.Gaau);

      //   if (
      //   Nav.Inventory.permission &&
      //   permissao.filter((x) => x.startsWith(Nav.Inventory.permission)).length > 0
      // )
      //   menu[0]._children.push(Nav.Inventory);

      menu[0]._children.push(Nav.Configuracao);

      if (
        Nav.Parametro.permission &&
        permissao.filter((x) => x.startsWith(Nav.Parametro.permission)).length >
          0
      )
        menu[0]._children.push(Nav.Parametro);

      if (
        Nav.Usuarios.permission &&
        permissao.filter((x) => x.startsWith(Nav.Usuarios.permission)).length >
          0
      )
        menu[0]._children.push(Nav.Usuarios);

      if (
        Nav.GrupoUsuario.permission &&
        permissao.filter((x) => x.startsWith(Nav.GrupoUsuario.permission))
          .length > 0
      )
        menu[0]._children.push(Nav.GrupoUsuario);

      if (
        Nav.Pergunta.permission &&
        permissao.filter((x) => x.startsWith(Nav.Pergunta.permission)).length >
          0
      )
        menu[0]._children.push(Nav.Pergunta);

      if (
        Nav.Transferencia.permission &&
        permissao.filter((x) => x.startsWith(Nav.Transferencia.permission))
          .length > 0
      )
        menu[0]._children.push(Nav.Transferencia);

      if (
        Nav.Carbono.permission &&
        permissao.filter((x) => x.startsWith(Nav.Carbono.permission)).length > 0
      )
        menu[0]._children.push(Nav.Carbono);

      if (
        Nav.PerguntaDinamica.permission &&
        permissao.filter((x) => x.startsWith(Nav.PerguntaDinamica.permission))
          .length > 0
      )
        menu[0]._children.push(Nav.PerguntaDinamica);

      return menu;
    }
  }
};
</script>

<style lang="scss">
.sidebar-image-logo {
  max-width: 85%;
  max-height: 85%;
  margin: 0.5rem 1rem 0.5rem 1rem;
}

.sidebar-image-small-logo {
  max-width: 85%;
  max-height: 85%;
  margin: 0.5rem 1rem 0.5rem 1rem;
}
</style>
